import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from 'src/app/shared/components/alert-box/alert-box.component';
import { OrderDetailsService } from '../../services/order-details/order-details.service';
import { PropertyUnitOrder } from '../../models/property-unit.model';

@Component({
    selector: 'app-property-unit',
    templateUrl: './property-unit.component.html',
    styleUrls: ['./property-unit.component.scss'],
    standalone: false
})
export class PropertyUnitComponent implements OnDestroy, OnInit {

  @Input() orderID: number | null = null;
  propertyUnitLoading = false;
  propertyUnit: PropertyUnitOrder | null = null;
  private saveDialogRef?: MatDialogRef<AlertBoxComponent>;

  constructor(
    private dialog: MatDialog,
    private orderDetailsService: OrderDetailsService
  ) { }

  ngOnInit(): void {
    if (this.orderID !== null) {
      this.propertyUnitLoading = true;
      this.orderDetailsService.getPropertyUnit(this.orderID).subscribe({
        next: (response) => {
          this.propertyUnit = response.data;
          this.propertyUnitLoading = false;
        },
        error: (error) => {
          console.error('Failed to fetch property unit details:', error);
          this.propertyUnitLoading = false;
        }
      });
    }
  }

  formatPropertyRelations(): string {
    return this.propertyUnit?.property_relations?.map(relation => relation.name).join(', ') || '-';
  }

  ngOnDestroy(): void {
    if (this.saveDialogRef) {
      this.saveDialogRef.close();
    }
  }

  async copyAddress(): Promise<void> {
    if (!this.propertyUnit?.location) {
      this.showAlertBox('لا يوجد موقع للنسخ', false);
      return;
    }

    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${this.propertyUnit.location}`;
    await this.copyToClipboard(mapsUrl);
  }

  private async copyToClipboard(text: string): Promise<void> {
    try {
      // Try modern Clipboard API first
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        this.showAlertBox('تم النسخ بنجاح', true);
      } else {
        // Fallback for older browsers or non-secure contexts
        this.fallbackCopy(text);
      }
    } catch (error) {
      console.error('Failed to copy to clipboard:', error);
      this.showAlertBox('فشل النسخ، يرجى المحاولة مرة أخرى', false);
    }
  }

  private fallbackCopy(text: string): void {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      const successful = document.execCommand('copy');
      if (successful) {
        this.showAlertBox('تم النسخ بنجاح', true);
      } else {
        this.showAlertBox('فشل النسخ، يرجى المحاولة مرة أخرى', false);
      }
    } catch (error) {
      console.error('Fallback copy failed:', error);
      this.showAlertBox('فشل النسخ، يرجى المحاولة مرة أخرى', false);
    } finally {
      document.body.removeChild(textArea);
    }
  }

  private showAlertBox(message: string, success: boolean): void {
    if (this.saveDialogRef) {
      this.saveDialogRef.close();
    }
    
    this.saveDialogRef = this.dialog.open(AlertBoxComponent, {
      data: {
        imgSuccess: success,
        message: message,
        button: 'تم',
      },
    });
  }
}
